<div
  id="moveableContainer"
  class="wrapper wrapper-content animated fadeInLeft exchangeTokensContainer"
>
  <!-- <div id="header" class="display-flex-left flex-align-center">
    <h1>
        <a (click)="goBack()"><i class="fa fa-angle-left"></i></a>
        &nbsp;
        {{ 'Menu.Results' | translate }}
    </h1>
  </div> -->
  <div class="display-flex-left results-margin">
    <div class="no-padding" id="sideHistory">
      <div class="" id="wrapper">
        <div id="sideHistoryTitle" *ngIf="sideHistoryItems">
          {{ 'ADMIN_LTI.ALL_PLANS' | translate }}
        </div>
        <div
          class="sideHistoryItem"
          *ngFor="let item of sideHistoryItems; let i = index"
          [ngClass]="{
            selected: isSelected(item),
            active: item.active,
            bozza: !item.isActive,
            definitivo: item.isActive
          }"
          (click)="selectPlan(item)"
        >
          <div class="sideHistoryItem-wrapper">
            <div class="title">
              <div class="sideHistoryItemTitle">{{ item.Name }}</div>
              <div class="sideHistoryItemExpiration">
                <span class="text-small" *ngIf="!item.IsDraft">
                  {{ 'ADMIN_LTI.SENT_ON' | translate }}
                  {{
                    'DYNAMIC_DATE'
                      | translate: { date: item.ActivationDate | localizedDate }
                  }}
                </span>
                <span class="text-small" *ngIf="item.IsDraft">
                  {{ 'ADMIN_LTI.NOT_SENT_YET' | translate }}
                </span>
                <span class="text-small" *ngIf="!item.Expires || !item.IsDraft">
                  &nbsp;
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="separator_v"></div>

    <div class="no-padding flex-fill-width" id="mainContainer">
      <div class="ibox float-e-margins" id="">
        <div class="ibox-content" *ngIf="currentPlan">
          <div id="result_detail-container">
            <div id="result_detail-header">
              <div id="result_detail-plan_name">
                <div class="result_detail-item_title">
                  {{ currentPlan.Name }}
                </div>
              </div>
              <div id="result_detail-header-closing_values">
                {{ 'ADMIN_LTI.CLOSING_VALUES' | translate }}
              </div>
            </div>

            <div class="display-flex-left">
              <div [ngClass]="{ largeView: currentView == 'results' }">
                <div class="result_detail-switch mainSwitch">
                  <div
                    class="result_detail-switch_item"
                    (click)="
                      currentYear = currentPlan.YearStart;
                      currentView = 'results'
                    "
                    [ngClass]="{ active: currentView == 'results' }"
                  >
                    {{ 'ADMIN_LTI.RESULTS.RESULTS' | translate }}
                  </div>
                  <div
                    class="result_detail-switch_item"
                    (click)="
                      currentYear = currentPlan.YearStart;
                      currentView = 'bonusDetail'
                    "
                    [ngClass]="{ active: currentView == 'bonusDetail' }"
                  >
                    {{ 'ADMIN_LTI.RESULTS.BONUS_DETAIL' | translate }}
                  </div>
                </div>

                <div class="result_detail-switch">
                  <div
                    class="result_detail-switch_item"
                    (click)="currentYear = year"
                    *ngFor="let year of plansLength(); let i = index"
                    [ngClass]="{ active: currentYear == year }"
                  >
                    {{ currentPlan.YearStart + i }}
                  </div>
                </div>

                <div id="resultsView" *ngIf="currentView == 'results'">
                  <div
                    id="result_detail-tables"
                    *ngIf="currentYear <= currentPlan.YearEnd"
                  >
                    <div id="result_detail-table-container">
                      <table id="result_detail-table" class="table">
                        <thead>
                          <tr>
                            <th>
                              {{
                                'ADMIN_LTI.RESULTS.GATEWAYS'
                                  | translate
                                  | uppercase
                              }}
                            </th>
                            <th class="inputCol">
                              {{
                                'ADMIN_LTI.GATEWAYS.BODY.YEARLY_VALUE'
                                  | translate
                                  | uppercase
                              }}
                            </th>
                            <th class="inputCol">
                              {{
                                'ADMIN_LTI.RESULTS.VALUE'
                                  | translate
                                  | uppercase
                              }}
                            </th>
                            <th></th>
                            <th>
                              {{
                                'PARTECIPANT_LTI.OBJECTIVES.COLUMNS.MEASURE'
                                  | translate
                              }}
                            </th>
                            <th>
                              {{
                                'ADMIN_LTI.RESULTS.TARGET'
                                  | translate
                                  | uppercase
                              }}
                            </th>
                            <th>
                              {{
                                'ADMIN_LTI.GATEWAYS.BODY.MIN'
                                  | translate
                                  | uppercase
                              }}
                            </th>
                            <th>
                              {{
                                'ADMIN_LTI.GATEWAYS.BODY.MAX'
                                  | translate
                                  | uppercase
                              }}
                            </th>
                            <th>
                              {{
                                'ADMIN_LTI.RESULTS.SENSIVITY'
                                  | translate
                                  | uppercase
                              }}
                            </th>
                            <th>
                              {{
                                'ADMIN_LTI.GATEWAYS.BODY.WEIGHT'
                                  | translate
                                  | uppercase
                              }}
                            </th>
                            <th>
                              {{
                                'ADMIN_LTI.RESULTS.MULTIPLIER'
                                  | translate
                                  | uppercase
                              }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <!-- GATEWAYS -->
                          <tr *ngFor="let gateway of currentPlan.Gateways">
                            <td>{{ gateway.Goal.Name }}</td>
                            <td>
                              <input
                                type="text"
                                name=""
                                [ngClass]="{
                                  invalid:
                                    gateway.Map.YearlyValues[currentYear]
                                      .hasError
                                }"
                                class="form-control"
                                [(ngModel)]="
                                  gateway.Map.YearlyValues[currentYear]
                                    .CurrentValue
                                "
                                (ngModelChange)="
                                  onValueChange(
                                    gateway,
                                    gateway.Map.YearlyValues[currentYear]
                                  )
                                "
                              />
                            </td>
                            <td>
                              <input
                                disabled
                                type="text"
                                name=""
                                class="form-control"
                                *ngIf="
                                  !gateway.Map.YearlyValues[currentYear]
                                    .CurrentValue
                                "
                              />
                              <input
                                disabled
                                type="text"
                                name=""
                                class="form-control"
                                *ngIf="
                                  gateway.Map.YearlyValues[currentYear]
                                    .CurrentValue
                                "
                                [ngModel]="
                                  formatValue(
                                    gateway,
                                    gateway.Map.YearlyValues[currentYear]
                                      .calcCurrentValue
                                  )
                                "
                              />
                            </td>
                            <td>
                              <i
                                placement="top"
                                tooltip="{{
                                  getTooltipConsultationType(
                                    gateway.ConsultationType
                                  )
                                }}"
                                class="{{ getIcon(gateway.ConsultationType) }}"
                                [ngClass]="{
                                  'text-success': isSuccessTarget(
                                    gateway.Map.YearlyValues[currentYear]
                                  ),
                                  'text-danger': !isSuccessTarget(
                                    gateway.Map.YearlyValues[currentYear]
                                  )
                                }"
                              ></i>
                            </td>
                            <td>{{ getMeasure(gateway) }}</td>
                            <td>
                              {{
                                formatValue(
                                  gateway,
                                  gateway.Map.YearlyValues[currentYear]
                                    .calcTargetValue
                                )
                              }}
                            </td>
                            <td>
                              {{
                                getMin(
                                  gateway,
                                  gateway.Map.YearlyValues[currentYear]
                                    .calcTargetValue
                                )
                              }}
                            </td>
                            <td>
                              {{
                                getMax(
                                  gateway,
                                  gateway.Map.YearlyValues[currentYear]
                                    .calcTargetValue
                                )
                              }}
                            </td>
                            <td>{{ getSensitive(gateway) }}</td>
                            <td>{{ gateway.Weight }}</td>
                            <td>
                              {{
                                getMultiplier(
                                  gateway.Map.YearlyValues[currentYear]
                                )
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td colspan="10" class="footer">
                              {{
                                'ADMIN_LTI.RESULTS.TARGET_BONUS_MULTIPLIER'
                                  | translate
                              }}
                            </td>
                            <td class="footer">
                              {{ getTotMultiplier('gateway', currentYear) }}
                            </td>
                          </tr>
                          <!-- OBJECTIVES -->
                          <tr>
                            <th colspan="11" class="header">
                              {{
                                'ADMIN_LTI.RESULTS.OBJECTIVES'
                                  | translate
                                  | uppercase
                              }}
                            </th>
                          </tr>
                          <tr *ngFor="let objective of currentPlan.Objectives">
                            <td>{{ objective.Goal.Name }}</td>
                            <td>
                              <input
                                type="text"
                                name=""
                                class="form-control"
                                [(ngModel)]="
                                  objective.Map.YearlyValues[currentYear]
                                    .CurrentValue
                                "
                              />
                            </td>
                            <td>
                              <input
                                disabled
                                type="text"
                                name=""
                                class="form-control"
                                *ngIf="
                                  !objective.Map.YearlyValues[currentYear]
                                    .CurrentValue
                                "
                              />
                              <input
                                disabled
                                type="text"
                                name=""
                                class="form-control"
                                *ngIf="
                                  objective.Map.YearlyValues[currentYear]
                                    .CurrentValue
                                "
                                [ngModel]="
                                  formatValue(
                                    objective,
                                    objective.Map.YearlyValues[currentYear]
                                      .calcCurrentValue
                                  )
                                "
                              />
                            </td>
                            <td>
                              <i
                                placement="top"
                                tooltip="{{
                                  getTooltipConsultationType(
                                    objective.ConsultationType
                                  )
                                }}"
                                class="{{
                                  getIcon(objective.ConsultationType)
                                }}"
                                [ngClass]="{
                                  'text-success': isSuccessTarget(
                                    objective.Map.YearlyValues[currentYear]
                                  ),
                                  'text-danger': !isSuccessTarget(
                                    objective.Map.YearlyValues[currentYear]
                                  )
                                }"
                              ></i>
                            </td>
                            <td>{{ getMeasure(objective) }}</td>
                            <td>
                              {{
                                formatValue(
                                  objective,
                                  objective.Map.YearlyValues[currentYear]
                                    .calcTargetValue
                                )
                              }}
                            </td>
                            <td>
                              {{
                                getMin(
                                  objective,
                                  objective.Map.YearlyValues[currentYear]
                                    .calcTargetValue
                                )
                              }}
                            </td>
                            <td>
                              {{
                                getMax(
                                  objective,
                                  objective.Map.YearlyValues[currentYear]
                                    .calcTargetValue
                                )
                              }}
                            </td>
                            <td>{{ getSensitive(objective) }}</td>
                            <td>{{ objective.Weight }}</td>
                            <td>
                              {{
                                getMultiplier(
                                  objective.Map.YearlyValues[currentYear]
                                )
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td colspan="10" class="footer">
                              {{
                                'ADMIN_LTI.RESULTS.ADMITTED_BONUS_MULTIPLIER'
                                  | translate
                              }}
                            </td>
                            <td class="footer">
                              {{ getTotMultiplier('objective', currentYear) }}
                            </td>
                          </tr>
                          <!-- CORRECTIVE -->
                          <tr>
                            <th colspan="11" class="header">
                              {{
                                'ADMIN_LTI.RESULTS.BONUS_BANK_CORRECTIVES'
                                  | translate
                                  | uppercase
                              }}
                            </th>
                          </tr>
                          <tr
                            *ngFor="let corrective of currentPlan.Correctives"
                          >
                            <td>{{ corrective.Goal.Name }}</td>
                            <td>
                              <input
                                type="text"
                                name=""
                                class="form-control"
                                [(ngModel)]="
                                  corrective.Map.YearlyValues[currentYear]
                                    .CurrentValue
                                "
                              />
                            </td>
                            <td>
                              <input
                                disabled
                                type="text"
                                name=""
                                class="form-control"
                                *ngIf="
                                  !corrective.Map.YearlyValues[currentYear]
                                    .CurrentValue
                                "
                              />
                              <input
                                disabled
                                type="text"
                                name=""
                                class="form-control"
                                *ngIf="
                                  corrective.Map.YearlyValues[currentYear]
                                    .CurrentValue
                                "
                                [ngModel]="
                                  formatValue(
                                    corrective,
                                    corrective.Map.YearlyValues[currentYear]
                                      .calcCurrentValue
                                  )
                                "
                              />
                            </td>
                            <td>
                              <i
                                placement="top"
                                tooltip="{{
                                  getTooltipConsultationType(
                                    corrective.ConsultationType
                                  )
                                }}"
                                class="{{
                                  getIcon(corrective.ConsultationType)
                                }}"
                                [ngClass]="{
                                  'text-success': isSuccessTarget(
                                    corrective.Map.YearlyValues[currentYear]
                                  ),
                                  'text-danger': !isSuccessTarget(
                                    corrective.Map.YearlyValues[currentYear]
                                  )
                                }"
                              ></i>
                            </td>
                            <td>{{ getMeasure(corrective) }}</td>
                            <td>
                              {{
                                formatValue(
                                  corrective,
                                  corrective.Map.YearlyValues[currentYear]
                                    .calcTargetValue
                                )
                              }}
                            </td>
                            <td>
                              {{
                                getMin(
                                  corrective,
                                  corrective.Map.YearlyValues[currentYear]
                                    .calcTargetValue
                                )
                              }}
                            </td>
                            <td>
                              {{
                                getMax(
                                  corrective,
                                  corrective.Map.YearlyValues[currentYear]
                                    .calcTargetValue
                                )
                              }}
                            </td>
                            <td>{{ getSensitive(corrective) }}</td>
                            <td>{{ corrective.Weight }}</td>
                            <td>
                              {{
                                getMultiplier(
                                  corrective.Map.YearlyValues[currentYear]
                                )
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td colspan="10" class="footer">
                              {{
                                'ADMIN_LTI.RESULTS.BONUS_BANK_MULTIPLIER'
                                  | translate
                              }}
                            </td>
                            <td class="footer">
                              {{ getTotMultiplier('corrective', currentYear) }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div
                    id="pastYearsPayable"
                    class="tablesSummary"
                    *ngIf="currentYear > currentPlan.YearEnd"
                  >
                    <div id="accruedTable">
                      <div
                        class="display-flex-space-between"
                        id="accruedTableHeader"
                      >
                        <span>
                          {{ currentYear }}&nbsp;{{
                            'ADMIN_LTI.RESULTS.PAST_YEARS_PAYABLE'
                              | translate
                              | uppercase
                          }}
                        </span>
                        <span>{{ getPastYearsPayable(currentYear) }}</span>
                      </div>
                      <div
                        class="display-flex-space-between more_details"
                        *ngIf="currentPlan.PayoutStructure.PayoutType == 2"
                      >
                        <span>
                          {{
                            'ADMIN_LTI.PAYOUT.BODY.CASH' | translate | uppercase
                          }}
                        </span>
                        <span>{{ getPastYearsPayableCash(currentYear) }}</span>
                      </div>
                      <div
                        class="display-flex-space-between more_details"
                        *ngIf="currentPlan.PayoutStructure.PayoutType == 2"
                      >
                        <span>
                          {{
                            'ADMIN_LTI.PAYOUT.BODY.EQUITY'
                              | translate
                              | uppercase
                          }}
                        </span>
                        <span>
                          {{ getPastYearsPayableEquity(currentYear) }}
                        </span>
                      </div>
                    </div>

                    <div class="whiteTable">
                      <div class="display-flex-space-between">
                        <span>
                          {{
                            'ADMIN_LTI.RESULTS.ACCRUED_IN'
                              | translate
                              | uppercase
                          }}
                        </span>
                        <span>&nbsp;</span>
                      </div>
                      <ng-template
                        ngFor
                        let-item
                        let-col="index"
                        [ngForOf]="getPastYearsPayableArray(currentYear)"
                      >
                        <div class="display-flex-space-between">
                          <span>{{ item }}</span>
                          <span>{{ getPastYearsPayable(item) }}</span>
                        </div>
                        <div
                          class="display-flex-space-between more_details"
                          *ngIf="currentPlan.PayoutStructure.PayoutType == 2"
                        >
                          <span>
                            {{
                              'ADMIN_LTI.PAYOUT.BODY.CASH'
                                | translate
                                | uppercase
                            }}
                          </span>
                          <span>{{ getPastYearsPayableCash(item) }}</span>
                        </div>
                        <div
                          class="display-flex-space-between more_details"
                          *ngIf="currentPlan.PayoutStructure.PayoutType == 2"
                        >
                          <span>
                            {{
                              'ADMIN_LTI.PAYOUT.BODY.EQUITY'
                                | translate
                                | uppercase
                            }}
                          </span>
                          <span>{{ getPastYearsPayableEquity(item) }}</span>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>

                <div
                  id="bonusDetail"
                  *ngIf="
                    currentView == 'bonusDetail' &&
                    currentYear <= currentPlan.YearEnd
                  "
                >
                  <div class="bonusTableContainer">
                    <table id="employeeTable" class="table">
                      <thead>
                        <tr>
                          <th class="columnEmployee">
                            {{ 'Generic.Employee' | translate }}
                          </th>
                          <th>{{ 'ADMIN_LTI.RESULTS.ACCRUED' | translate }}</th>
                          <th>{{ 'ADMIN_LTI.RESULTS.PAYABLE' | translate }}</th>
                          <th
                            *ngIf="currentPlan.PayoutStructure.PayoutType == 2"
                          >
                            {{ 'ADMIN_LTI.PAYOUT.BODY.CASH' | translate }}
                          </th>
                          <th
                            *ngIf="currentPlan.PayoutStructure.PayoutType == 2"
                          >
                            {{ 'ADMIN_LTI.PAYOUT.BODY.EQUITY' | translate }}
                          </th>
                          <th>
                            {{ 'ADMIN_LTI.RESULTS.DEFERRED' | translate }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="
                            let partecipant of getPartecipantsByYear(
                              currentYear
                            )
                          "
                        >
                          <td class="columnEmployee">
                            <div
                              class="template-compare-employee display-flex-left flex-align-center"
                            >
                              <div class="template-compare-employee-image">
                                <img
                                  class="user-image-round-bordered"
                                  [src]="
                                    coreService.getImageURL(
                                      partecipant.Picture,
                                      'assets/images/user.jpeg'
                                    )
                                  "
                                />
                              </div>
                              <div class="template-compare-employee-info">
                                <div class="template-compare-employee-name">
                                  &nbsp;{{ partecipant.SecondName }}
                                  {{ partecipant.FirstName }}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td>
                            {{
                              getBonusAccruedPartecipant(
                                currentYear,
                                partecipant
                              )
                            }}
                          </td>
                          <td>
                            {{
                              getBonusPayablePartecipant(
                                currentYear,
                                partecipant
                              )
                            }}
                          </td>
                          <td
                            *ngIf="currentPlan.PayoutStructure.PayoutType == 2"
                          >
                            {{
                              getBonusCashPartecipant(currentYear, partecipant)
                            }}
                          </td>
                          <td
                            *ngIf="currentPlan.PayoutStructure.PayoutType == 2"
                          >
                            {{
                              getBonusEquityPartecipant(
                                currentYear,
                                partecipant
                              )
                            }}
                          </td>
                          <td>
                            {{
                              getBonusDeferredPartecipant(
                                currentYear,
                                partecipant
                              )
                            }}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <th class="columnEmployee">
                            {{ 'Generic.Total' | translate }}
                          </th>
                          <th>
                            <strong>
                              {{ getTotalBonusAccruedPartecipant(currentYear) }}
                            </strong>
                          </th>
                          <th>
                            <strong>
                              {{ getTotalBonusPayablePartecipant(currentYear) }}
                            </strong>
                          </th>
                          <th
                            *ngIf="currentPlan.PayoutStructure.PayoutType == 2"
                          >
                            {{ getTotalBonusCashPartecipant(currentYear) }}
                          </th>
                          <th
                            *ngIf="currentPlan.PayoutStructure.PayoutType == 2"
                          >
                            {{ getTotalBonusEquityPartecipant(currentYear) }}
                          </th>
                          <th>
                            <strong>
                              {{
                                getTotalBonusDeferredPartecipant(currentYear)
                              }}
                            </strong>
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>

                  <div _ngcontent-c8="" class="separator_v"></div>

                  <div class="bonusTableContainer">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>
                            {{
                              'ADMIN_LTI.RESULTS.BONUS_BANK_OPENING' | translate
                            }}
                          </th>
                          <th>
                            {{
                              'ADMIN_LTI.RESULTS.PAST_YEARS_PAYABLE' | translate
                            }}
                          </th>
                          <th>
                            {{ currentYear }}&nbsp;{{
                              'ADMIN_LTI.RESULTS.DEFERRED' | translate
                            }}
                          </th>
                          <th>
                            {{
                              'ADMIN_LTI.RESULTS.BONUS_BANK_CLOSING' | translate
                            }}
                          </th>
                          <th>
                            {{ 'ADMIN_LTI.RESULTS.TOTAL_PAYABLE' | translate }}
                          </th>
                          <th
                            *ngIf="currentPlan.PayoutStructure.PayoutType == 2"
                          >
                            {{ 'ADMIN_LTI.PAYOUT.BODY.CASH' | translate }}
                          </th>
                          <th
                            *ngIf="currentPlan.PayoutStructure.PayoutType == 2"
                          >
                            {{ 'ADMIN_LTI.PAYOUT.BODY.EQUITY' | translate }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="
                            let partecipant of getPartecipantsByYear(
                              currentYear
                            )
                          "
                        >
                          <td>
                            {{
                              getBonusDetailBankOpening(
                                currentYear,
                                partecipant
                              )
                            }}
                          </td>
                          <td>
                            {{
                              getBonusDetailPastYearsPayable(
                                currentYear,
                                partecipant
                              )
                            }}
                          </td>
                          <td>
                            {{
                              getBonusDetailDeferred(currentYear, partecipant)
                            }}
                          </td>
                          <td>
                            {{
                              getBonusDetailBankClosing(
                                currentYear,
                                partecipant
                              )
                            }}
                          </td>
                          <td>
                            {{
                              getBonusDetailTotalPayable(
                                currentYear,
                                partecipant
                              )
                            }}
                          </td>
                          <td
                            *ngIf="currentPlan.PayoutStructure.PayoutType == 2"
                          >
                            {{ getBonusDetailCash(currentYear, partecipant) }}
                          </td>
                          <td
                            *ngIf="currentPlan.PayoutStructure.PayoutType == 2"
                          >
                            {{ getBonusDetailEquity(currentYear, partecipant) }}
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td>
                            {{ getTotalBonusDetailBankOpening(currentYear) }}
                          </td>
                          <td>
                            {{
                              getTotalBonusDetailPastYearsPayable(currentYear)
                            }}
                          </td>
                          <td>
                            {{ getTotalBonusDetailDeferred(currentYear) }}
                          </td>
                          <td>
                            {{ getTotalBonusDetailBankClosing(currentYear) }}
                          </td>
                          <td>
                            {{ getTotalBonusDetailTotalPayable(currentYear) }}
                          </td>
                          <td
                            *ngIf="currentPlan.PayoutStructure.PayoutType == 2"
                          >
                            {{ getTotalBonusDetailCash(currentYear) }}
                          </td>
                          <td
                            *ngIf="currentPlan.PayoutStructure.PayoutType == 2"
                          >
                            {{ getTotalBonusDetailEquity(currentYear) }}
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <div
                  id="bonusDetail"
                  *ngIf="
                    currentView == 'bonusDetail' &&
                    currentYear > currentPlan.YearEnd
                  "
                >
                  <table class="table">
                    <thead>
                      <tr>
                        <th></th>
                        <th class="blue" colspan="2">
                          {{ currentYear }}&nbsp;{{
                            'ADMIN_LTI.RESULTS.PAST_YEARS_PAYABLE' | translate
                          }}
                        </th>
                        <th
                          class="grey text-center-important"
                          [attr.colspan]="
                            getPastYearsPayableArray(currentYear).length
                          "
                        >
                          {{
                            'ADMIN_LTI.RESULTS.ACCRUED_IN'
                              | translate
                              | uppercase
                          }}
                        </th>
                      </tr>
                      <tr>
                        <th></th>
                        <th class="blue">
                          {{ 'ADMIN_LTI.PAYOUT.BODY.CASH' | translate }}
                        </th>
                        <th class="blue">
                          {{ 'ADMIN_LTI.PAYOUT.BODY.EQUITY' | translate }}
                        </th>
                        <th
                          class="grey"
                          *ngFor="
                            let year of getPastYearsPayableArray(currentYear)
                          "
                        >
                          {{ year }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        *ngFor="
                          let partecipant of getPartecipantsByYear(currentYear)
                        "
                      >
                        <td class="blue">
                          <div
                            class="template-compare-employee display-flex-left flex-align-center"
                          >
                            <div class="template-compare-employee-image">
                              <img
                                class="user-image-round-bordered"
                                [src]="
                                  coreService.getImageURL(
                                    partecipant.Picture,
                                    'assets/images/user.jpeg'
                                  )
                                "
                              />
                            </div>
                            <div class="template-compare-employee-info">
                              <div class="template-compare-employee-name">
                                &nbsp;{{ partecipant.SecondName }}
                                {{ partecipant.FirstName }}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td class="blue">
                          {{ getBonusDetailCash(currentYear, partecipant) }}
                        </td>
                        <td class="blue">
                          {{ getBonusDetailEquity(currentYear, partecipant) }}
                        </td>
                        <ng-template
                          ngFor
                          let-item
                          let-col="index"
                          [ngForOf]="getPastYearsPayableArray(currentYear)"
                        >
                          <td class="grey">
                            {{ getBonusDetailCash(item, partecipant) }}
                          </td>
                          <td class="grey">
                            {{ getBonusDetailEquity(item, partecipant) }}
                          </td>
                        </ng-template>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="separator_v" *ngIf="currentView == 'results'"></div>

              <div id="narrowView" *ngIf="currentView == 'results'">
                <div class="tablesSummary">
                  <div class="greyTable">
                    <div class="display-flex-space-between">
                      <span>
                        {{
                          'ADMIN_LTI.GATEWAYS.BODY.TARGET_BONUS'
                            | translate
                            | uppercase
                        }}
                      </span>
                      <span>{{ getSummaryTargetBonus(currentYear) }}</span>
                    </div>
                  </div>
                  <div class="greyTable">
                    <div class="display-flex-space-between">
                      <span>
                        {{
                          'ADMIN_LTI.GATEWAYS.BODY.ADMITTED_BONUS'
                            | translate
                            | uppercase
                        }}
                      </span>
                      <span>{{ getSummaryAdmittedBonus(currentYear) }}</span>
                    </div>
                  </div>
                  <div id="accruedTable">
                    <div
                      class="display-flex-space-between"
                      id="accruedTableHeader"
                    >
                      <span>
                        {{ currentYear }}&nbsp;{{
                          'ADMIN_LTI.RESULTS.ACCRUED' | translate | uppercase
                        }}
                      </span>
                      <span>{{ getSummaryAccrued(currentYear) }}</span>
                    </div>
                    <div class="display-flex-space-between">
                      <span>
                        {{ currentYear }}&nbsp;{{
                          'ADMIN_LTI.RESULTS.PAYABLE' | translate | uppercase
                        }}
                      </span>
                      <span>{{ getSummaryPayable(currentYear) }}</span>
                    </div>
                    <div
                      class="display-flex-space-between more_details"
                      *ngIf="currentPlan.PayoutStructure.PayoutType == 2"
                    >
                      <span>
                        {{
                          'ADMIN_LTI.PAYOUT.BODY.CASH' | translate | uppercase
                        }}
                      </span>
                      <span>{{ getSummaryPayableCash(currentYear) }}</span>
                    </div>
                    <div
                      class="display-flex-space-between more_details"
                      *ngIf="currentPlan.PayoutStructure.PayoutType == 2"
                    >
                      <span>
                        {{
                          'ADMIN_LTI.PAYOUT.BODY.EQUITY' | translate | uppercase
                        }}
                      </span>
                      <span>{{ getSummaryPayableEquity(currentYear) }}</span>
                    </div>
                    <div class="display-flex-space-between">
                      <span>
                        {{ currentYear }}&nbsp;{{
                          'ADMIN_LTI.RESULTS.DEFERRED' | translate | uppercase
                        }}
                      </span>
                      <span>{{ getSummaryDeferred(currentYear) }}</span>
                    </div>
                    <div
                      class="display-flex-space-between more_details"
                      *ngIf="currentPlan.PayoutStructure.PayoutType == 2"
                    >
                      <span>
                        {{
                          'ADMIN_LTI.PAYOUT.BODY.CASH' | translate | uppercase
                        }}
                      </span>
                      <span>{{ getSummaryDeferredCash(currentYear) }}</span>
                    </div>
                    <div
                      class="display-flex-space-between more_details"
                      *ngIf="currentPlan.PayoutStructure.PayoutType == 2"
                    >
                      <span>
                        {{
                          'ADMIN_LTI.PAYOUT.BODY.EQUITY' | translate | uppercase
                        }}
                      </span>
                      <span>{{ getSummaryDeferredEquity(currentYear) }}</span>
                    </div>
                  </div>
                  <div class="greyTable">
                    <div class="display-flex-space-between">
                      <span>
                        {{
                          'ADMIN_LTI.RESULTS.BONUS_BANK_OPENING'
                            | translate
                            | uppercase
                        }}
                      </span>
                      <span>{{ getSummaryBonusBankOpening(currentYear) }}</span>
                    </div>
                    <div class="display-flex-space-between more_details">
                      <span>
                        {{
                          'ADMIN_LTI.RESULTS.PAST_YEARS_PAYABLE'
                            | translate
                            | uppercase
                        }}
                      </span>
                      <span>{{ getSummaryPastYearPayable(currentYear) }}</span>
                    </div>
                    <div class="display-flex-space-between more_details">
                      <span>
                        {{ currentYear }}&nbsp;{{
                          'ADMIN_LTI.RESULTS.DEFERRED' | translate | uppercase
                        }}
                      </span>
                      <span>{{ getSummaryDeferred(currentYear) }}</span>
                    </div>
                    <div class="display-flex-space-between">
                      <span>
                        {{
                          'ADMIN_LTI.RESULTS.BONUS_BANK_BASE'
                            | translate
                            | uppercase
                        }}
                      </span>
                      <span>{{ getSummaryBonusBankBase(currentYear) }}</span>
                    </div>
                    <div
                      class="display-flex-space-between"
                      [ngClass]="{
                        theRed:
                          getSummaryBonusBankCorrectiveValue(currentYear) < 0
                      }"
                    >
                      <span>
                        {{
                          'ADMIN_LTI.RESULTS.BONUS_BANK_CORRECTIVES'
                            | translate
                            | uppercase
                        }}
                      </span>
                      <span>
                        {{ getSummaryBonusBankCorrective(currentYear) }}
                      </span>
                    </div>
                    <div class="display-flex-space-between">
                      <span>
                        {{
                          'ADMIN_LTI.RESULTS.BONUS_BANK_CLOSING'
                            | translate
                            | uppercase
                        }}
                      </span>
                      <span>{{ getSummaryBonusBankClosing(currentYear) }}</span>
                    </div>
                  </div>
                </div>

                <button
                  id="addNewButton"
                  (click)="sendResults()"
                  [disabled]="checkDisabled()"
                  [ngClass]="
                    checkDisabled() ? 'sendRequestDisabled' : 'sendRequest'
                  "
                >
                  {{ 'ADMIN_LTI.SEND_RESULTS' | translate | uppercase }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
